/** Reports list — parent screen for in-app report shells opened from the catalog. */
export const REPORTS_CATALOG_PATH = "/projects/reports/catalog";

export function goToReportsCatalog(history) {
  history.push(REPORTS_CATALOG_PATH);
}
